import { jsx as _jsx } from "react/jsx-runtime";
import { ForumSectionItem } from "@bluframe/mightychroma-mightytool-ui";
const Item = ({ isEditing, item, onCancel, onDelete, onEdit, onSave }) => (_jsx(ForumSectionItem, { isEditing: isEditing, item: item, onCancel: onCancel, onDelete: onDelete, onEdit: onEdit, onSave: onSave }));
export default Item;
